import actionType from '../enums/actions'

const initState = {
	list: {
		data: [],
		actualPage: 1,
		totalBanners: 0,
		pageSize: 10,
		order: null,
		search: null,
		isLoading: false,
		isFailure: false
	},
	detail: {
		data: {
			title: '',
			subtitle: '', 
			image: '',
			url: '',
			brand: '',
			applications: []
		},
		isLoading: false,
		isFailure: false
	}
}

const bannerReducer = (state = initState, action) => {
	switch (action.type) {
		case actionType.banner.SET_LISTING_PARAMS: {
			return {
				...state,
				list: {
					...state.list,
					actualPage: action.data.page,
					pageSize: action.data.pageSize,
					order: action.data.order,
					search: action.data.search
				}
			}
		}
		case actionType.banner.GET_BANNERS_REQUEST: {
			return {
				...state,
				list: {
					...state.list,
					isLoading: true
				}
			
			}
		}
		case actionType.banner.GET_BANNERS_SUCCESS: {
			return {
				...state,
				list: {
					...state.list,
					data: action.data.banners,
					totalBanners: action.data.totalBanners,
					isLoading: false,
					isFailure: false
				}
			}
		}
		case actionType.banner.GET_BANNERS_ERROR: {
			return {
				...state,
				list: {
					...state.list,
					isLoading: false,
					isFailure: true
				}
			}
		}
		case actionType.banner.GET_BANNER_REQUEST: {
			return {
				...state,
				detail: {
					...state.detail,
					isLoading: true
				}
			}
		}
		case actionType.banner.GET_BANNER_SUCCESS: {
			return {
				...state,
				detail: {
					...state.detail,
					data: action.banner,
					isLoading: false,
					isFailure: false
				}
			}
		}
		case actionType.banner.GET_BANNER_ERROR: {
			return {
				...state,
				detail: {
					...state.detail,
					isLoading: false,
					isFailure: true
				}
			}
		}
		case actionType.banner.CREATE_BANNER_REQUEST: {
			return state
		}
		case actionType.banner.CREATE_BANNER_SUCCESS: {
			return state
		}
		case actionType.banner.CREATE_BANNER_ERROR: {
			return state
		}
		case actionType.banner.UPDATE_BANNER_REQUEST: {
			return state
		}
		case actionType.banner.UPDATE_BANNER_SUCCESS: {
			return state
		}
		case actionType.banner.UPDATE_BANNER_ERROR: {
			return state
		}
		case actionType.banner.DELETE_BANNER_REQUEST: {
			return state
		}
		case actionType.banner.DELETE_BANNER_SUCCESS: {
			return state
		}
		case actionType.banner.DELETE_BANNER_ERROR: {
			return state
		}
		case actionType.RESET_STATE: {
			return {
				...initState
			}
		}
		default:
			return state
	}
}

export default bannerReducer
